import React, { useState } from "react";

import Step from "components/MainApp/atoms/Wizard/Step";
import ProductAddedList from "components/MainApp/organisms/Orders/RequestOrders/ProductAddedList";
import SearchWithComponents from "components/MainApp/atoms/Filters/SearchWithComponents";
import MainInput from "components/MainApp/atoms/Forms/MainInput";
import { isMobile } from "helpers/Mobile";
import TwoOptionModal from "components/MainApp/atoms/Modals/TwoOptionModal";

import styles from "./Step1.module.scss";
import useRequest from "hooks/useRequest";
import { ProductService } from "services/ProductService";
import Loader from "components/MainApp/atoms/Loader";
import { PublicService } from "services/PublicService";
import UploadButton from "shared/components/buttons/upload-button";
import trashIcon from "assets/images/trash-icon.svg";
import BatchTagsErrorModal from "../../BatchTagsErrorModal";
import * as XLSX from "xlsx";
import i18n from "i18n";
import { capitalize } from "helpers/utils/utils_general";

export const AddTagStepOne = ({
  resultList,
  searchValue,
  handleChange,
  products,
  totalProducts,
  handleSelectToAddProduct,
  handleSelectedProductQuantityChange,
  handleAdd,
  handleAddProduct,
  handleDeleteAddedProduct,
  selectedProducts,
  changePage,
  pagination,
  type,
  tag,
  handleContinue,
  error,
  enableContinue,
  handleSelectAllSearchedItems,
  allSearchItemsSelected,
  handleClose,
  handlePersist,
  modalPersistOpen,
  onlyCloseModal,
  filter,
  validateFile,
  validateHeadersFile,
  insertProducts,
  showModalErrorFile,
  setShowModalErrorFile,
  downloadErrorFile
}) => {
  const {
    loading,
    beforeSubmit,
    afterSubmit,
    errors,
    dealWithError
  } = useRequest();

  const handleConfirm = () => handlePersist();
  const handleCloseIcon = () => onlyCloseModal();

  const mwidth = isMobile ? "100% " : "322px";
  const modalContent = "";

  const filterProducts = (value) => filter(value);

  const handleFileUpload = (event) => {
    const file = event.target.files[0];

    if (!validateFile(file)) return false;

    const reader = new FileReader();

    reader.onload = (e) => {
      const binaryStr = e.target.result;
      const workbook = XLSX.read(binaryStr, { type: "binary" });

      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      if (!validateHeadersFile(sheet)) return false;

      const sheetData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

      insertProducts(sheetData);
    };

    reader.readAsBinaryString(file);
  };

  const stepContent = (
    <div className={styles["add-tag-step-one-content"]}>
      <header>
        <h3>{i18n.t("product.want.to.print.tags")}</h3>
        <UploadButton handleFileUpload={handleFileUpload} className={styles["upload-tags-button"]} />
      </header>
      <div className={styles["add-tag-step-one-field"]} data-automation-id="input-search">
        <SearchWithComponents
          onlyStockHidden={true}
          placeholder={i18n.t("search.by.name.or.code")}
          resultList={resultList}
          value={searchValue}
          handleChange={handleChange}
          handleSelectToAddProduct={handleSelectToAddProduct}
          handleSelectedProductQuantityChange={
            handleSelectedProductQuantityChange
          }
          handleAdd={handleAdd}
          selectedProducts={selectedProducts}
          label={"Tags"}
          handleCheckbox={handleSelectAllSearchedItems}
          checkBoxChecked={allSearchItemsSelected}
          checkBoxLabel={i18n.t("all.products")}
          filterProducts={filterProducts}
          resultHeader={
            <header className={styles["search-with-components-results-header"]}>
              <p>{i18n.t("product")}</p>
              <p>{capitalize(i18n.t("tags"))}</p>
            </header>
          }
        />


        {products.length > 0 && (
          <ProductAddedList
            subtitle={false}
            total={totalProducts}
            products={products}
            edit={true}
            handleEdit={handleAddProduct}
            handleDelete={handleDeleteAddedProduct}
            changePage={changePage}
            pagination={pagination}
            title={i18n.t("total.loaded")}
            trashIcon={<img src={trashIcon} draggable={false} />}
          ></ProductAddedList>
        )}

        {/* Modal para mostrar los posible errores del fichero de importación  */}
        <BatchTagsErrorModal
          open={showModalErrorFile}
          handleClose={() => setShowModalErrorFile(false)}
          handleDownload={downloadErrorFile}
        />

      </div>
    </div>
  );

  const secondContent = (
    <form onSubmit={handleContinue} style={{width: "100%"}}>
      <div className={styles["add-tag-step-one-content"]}>
        <div
          className={styles["add-tag-step-one-field"]}
          data-automation-id="input-batch"
        >
          <MainInput
            label={i18n.t("batch")}
            id={"tag-batch"}
            required={true}
            name="batch"
            type="text"
            value={tag ? tag.batch : ""}
            handleChange={handleChange}
            maxLength={100}
            error={error.batch && error.batch}
          />
        </div>
        <div className={styles["add-tag-step-one-field"]} data-automation-id="input-date">
          <MainInput
            label={i18n.t("expiration.date")}
            required={true}
            id={"tag-due_date"}
            name="due_date"
            type="date"
            value={tag && tag.due_date != "" ? tag.due_date : null}
            handleChange={handleChange}
            maxLength={100}
            error={error.due_date && error.due_date}
          />
        </div>
        {type !== 'PRODUCT' && (
          <>
            <div
              className={styles["add-tag-step-one-field"]}
              data-automation-id="input-sscc"
            >
              <MainInput
                label={"SSCC"}
                id={"tag-sscc"}
                name="sscc"
                type="text"
                value={tag ? tag.sscc : ""}
                handleChange={handleChange}
                maxLength={100}
                error={error.sscc && error.sscc}
              />
            </div>
            <div
              className={styles["add-tag-step-one-field"]}
              data-automation-id="input-origin"
            >
              <MainInput
                label={i18n.t("place.of.origin")}
                id={"tag-origin"}
                name="origin"
                type="text"
                value={tag ? tag.origin : ""}
                handleChange={handleChange}
                maxLength={100}
                error={error.origin && error.origin}
              />
            </div>
            <div
              className={styles["add-tag-step-one-field"]}
              data-automation-id="input-destination"
            >
              <MainInput
                label={i18n.t("destination.location")}
                id={"tag-destination"}
                name="destination"
                type="text"
                value={tag ? tag.destination : ""}
                handleChange={handleChange}
                maxLength={100}
                error={error.destination && error.destination}
              />
            </div>
          </>
        )}
        <div className={styles["add-tag-step-one-action-wrapper"]}>
          <button
            type="submit"
            className={`${styles["add-tag-step-one-action-button"]} ${!enableContinue &&
              styles["disabled"]}`}
            onClick={enableContinue ? handleContinue : undefined}
            disabled={!enableContinue}
          >
            {i18n.t("generate.tags")}
          </button>
        </div>
      </div>
    </form>
  );

  return (
    <div className={styles["add-tag-step-one-container"]}>
      <Step
        content={stepContent}
        hideTitle={true}
      ></Step>
      <div className={styles["step-separator"]}>
        <Step content={secondContent}></Step>
      </div>
      <TwoOptionModal
        open={modalPersistOpen}
        title={i18n.t("pause.printing.tags")}
        subtitle={
          <span style={{ fontFamily: "Ubuntu-Medium", color: "#676F8F" }}>
           {i18n.t("exit.and.save.question")}
          </span>
        }
        closeLabel={i18n.t("exit.without.saving")}
        confirmLabel={i18n.t("save").toUpperCase()}
        handleClose={handleClose}
        handleConfirm={handleConfirm}
        modalContent={modalContent}
        confirmDisabled={false}
        closeable={true}
        handleCloseIcon={handleCloseIcon}
      />
      {loading && <Loader />}
    </div>
  );
};

export default AddTagStepOne;
